import { useState } from 'react';
import PropTypes from 'prop-types';

import { TableCell } from '@mui/material';

const Cell = ({ children, emptyElement = '-', width }) => {
  const [isOpen, setOpen] = useState(false);

  const baseStyles = { minWidth: width, maxWidth: 300, fontWeight: 400 };
  return (
    <TableCell
      width={width}
      onClick={() => setOpen(!isOpen)}
      sx={{
        ...baseStyles,
        ...(!isOpen && { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }),
      }}
    >
      {children || emptyElement}
    </TableCell>
  );
};

Cell.propTypes = {
  children: PropTypes.any,
  emptyElement: PropTypes.any,
  width: PropTypes.number,
};

export default Cell;
